import { styled } from "@mui/material";

export const ButtonContainer = styled("div")`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;
